export class CrosshairLayer {
  readonly element: HTMLElement;
  private visible = false;

  constructor() {
    this.element = document.createElement('div');
    this.element.className = 'crosshair-layer';
    this.element.innerHTML = this.buildMarkup();
  }

  show(): void {
    if (this.visible) return;
    this.visible = true;
    this.element.classList.add('is-visible');
  }

  hide(): void {
    if (!this.visible) return;
    this.visible = false;
    this.element.classList.remove('is-visible');
  }

  private buildMarkup(): string {
    return `
      <svg viewBox="-40 -40 80 80" width="72" height="72" aria-hidden="true">
        <circle cx="0" cy="0" r="1.8" fill="#ffd389"/>
        <circle cx="0" cy="0" r="22" fill="none"
          stroke="rgba(255, 211, 137, 0.25)" stroke-width="0.8"/>
        <line x1="-28" y1="0" x2="-11" y2="0"
          stroke="rgba(255, 211, 137, 0.85)" stroke-width="1.6" stroke-linecap="round"/>
        <line x1="28" y1="0" x2="11" y2="0"
          stroke="rgba(255, 211, 137, 0.85)" stroke-width="1.6" stroke-linecap="round"/>
        <line x1="0" y1="-28" x2="0" y2="-11"
          stroke="rgba(255, 211, 137, 0.85)" stroke-width="1.6" stroke-linecap="round"/>
        <line x1="0" y1="28" x2="0" y2="11"
          stroke="rgba(255, 211, 137, 0.85)" stroke-width="1.6" stroke-linecap="round"/>
        <polyline points="-14,-8 -10,-8 -10,-14"
          fill="none" stroke="rgba(156, 205, 255, 0.55)" stroke-width="1" stroke-linecap="round"/>
        <polyline points="14,-8 10,-8 10,-14"
          fill="none" stroke="rgba(156, 205, 255, 0.55)" stroke-width="1" stroke-linecap="round"/>
        <polyline points="-14,8 -10,8 -10,14"
          fill="none" stroke="rgba(156, 205, 255, 0.55)" stroke-width="1" stroke-linecap="round"/>
        <polyline points="14,8 10,8 10,14"
          fill="none" stroke="rgba(156, 205, 255, 0.55)" stroke-width="1" stroke-linecap="round"/>
      </svg>
    `;
  }
}
